import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";

function FaqOne({ dataFaq }) {
  return (
    <div>
      {/* Tmp FAQ area Start  */}
      <div className="faq-area faq-style-one faq-bg-image bg_image tmp-section-gap mt-dec--180">
        <div className="container pt--180">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                <div className="section-sub-title center-title">
                  <img
                    src="assets/images/services/section-custom-menubar.png "
                    alt="Corporate_service"
                  />
                  <span className="subtitle">{dataFaq?.subTitle}</span>
                </div>
                <h2 className="title split-collab">{dataFaq?.title}</h2>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="thumbnail">
                <img src={dataFaq?.img} alt="Setelec Consulting FAQ" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="faq-accordion">
                <Accordion defaultActiveKey="0">
                  {dataFaq?.items.map((item) => {
                    return (
                      <Accordion.Item eventKey={`${item.id}`} key={item.id}>
                        <Accordion.Header>
                          <div className="accordion-button-left">
                            <i className="fa-regular fa-lightbulb" />
                            <span>{item.question}</span>
                          </div>
                          <div className="accordion-button-right">
                            <i className="fa-sharp fa-light fa-arrow-right" />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>{item.answer}</Accordion.Body>
                      </Accordion.Item>
                    );
                  })}
                </Accordion>

                <div className="faq-buttom">
                  <h4 className="title">{dataFaq?.btnInfo}</h4>
                  <p>
                    Contactez Notre{" "}
                    <Link to={dataFaq?.btnLink}>Equipe D’experts</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Tmp FAQ area Start  */}
    </div>
  );
}

export default FaqOne;
